import "./AcademicAndResearch.module.css";
import Header from "@/reusable_sections/Header";
import ResearchHero from "./sections/ResearchHero";
import Applications from "./sections/Applications";
import TechnologyOverview from "./sections/TechnologyOverview";
import ResearchServices from "./sections/ResearchServices";
import AcademicEngagement from "./sections/AcademicEngagement";
import Footer from "@/reusable_sections/Footer";
export default function AcademicAndResearchPage() {
  return <div>
      <Header />
      <ResearchHero />
      <Applications />
      <TechnologyOverview />
      <ResearchServices />
      <AcademicEngagement />
      <Footer />
    </div>;
}